import { LEARNING_SUGGESTION_CHOICE } from "@/constants";
import { apiFetch } from "@/shared/api/apiFetch";
import { readApiErrorMessage } from "@/shared/api/parseApiErrorMessage";
import {
  type LearningSuggestion,
  parseLearningSuggestion,
} from "@/features/chat/model/chatTypes";

/** Save/dismiss answer the first question; the other two answer the domain question. */
export type LearningSuggestionChoice =
  (typeof LEARNING_SUGGESTION_CHOICE)[keyof typeof LEARNING_SUGGESTION_CHOICE];

/**
 * Answers the turn's offer to save a correction or preference the user stated. Saving writes the
 * user's own learning at once; suggesting puts it in the domain's Learning tab for review.
 * Returns the suggestion as the answer now carries it.
 */
export async function decideLearningSuggestion(
  turnId: string,
  choice: LearningSuggestionChoice,
): Promise<LearningSuggestion> {
  const res = await apiFetch(`/v1/chat/turns/${turnId}/learning-suggestion`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ choice }),
  });
  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }
  const suggestion = parseLearningSuggestion(await res.json());
  if (!suggestion) {
    throw new Error("Unexpected learning suggestion response");
  }
  return suggestion;
}
